import { Box, Flex } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { H3 } from '../Text';

interface SubjectBlockProps {
  subject: string;
}

const SubjectBlock: React.FC<SubjectBlockProps> = ({ subject, children }) => {
  const styles = useMultiStyleConfig('SubjectBlock', {});
  return (
    <Flex sx={styles.block}>
      <H3 sx={styles.subject}>{subject}</H3>
      <Box sx={styles.content}>{children}</Box>
    </Flex>
  );
};

export default SubjectBlock;
